import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [form, setForm] = useState({
    name: '',
    mobile: '',
    service: [],
    message: ''
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox' && name === 'service') {
      setForm((prev) => {
        const services = prev.service || [];
        return checked
          ? { ...prev, service: [...services, value] }
          : { ...prev, service: services.filter((s) => s !== value) };
      });
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.service.length) {
      setStatus('❌ Please select at least one service.');
      return;
    }

    window.open(
      'https://api.whatsapp.com/message/TWKAT7WPLF2UG1?autoload=1&app_absent=0',
      '_blank'
    );

    setStatus('✅ Redirecting to WhatsApp...');
    setForm({ name: '', mobile: '', service: [], message: '' });
  };

  return (
    <div className="contact-page">
      <div className="container">
        <h1 className="contact-title">Get in Touch</h1>
        <p className="contact-subtitle">
          We’re here to help you with home diagnostic services
        </p>

        <div className="contact-grid">

          {/* ================= CONTACT INFO ================= */}
          <div className="contact-info">
            <h3>📍 Our Address</h3>
            <p>
              Ground floor, Razak Manzil building,<br />
              Near Handsome Tailor, Opp. Shanti Niketan,<br />
              Mahim West, Mumbai – 400016
            </p>

            <a
              className="map-link"
              href="https://www.google.com/maps/search/?api=1&query=Razak+Manzil+Mahim+West+Mumbai"
              target="_blank"
              rel="noopener noreferrer"
            >
              📌 View on Google Maps
            </a>

            {/* Embedded Google Map */}
            <div className="map-embed">
              <iframe
                title="Vismit Envision Location"
                src="https://www.google.com/maps?q=Razak%20Manzil%20Mahim%20West%20Mumbai&output=embed"
                loading="lazy"
                allowFullScreen
              ></iframe>
            </div>

            <h3>📞 Call / WhatsApp</h3>
            <p>
              <a href="tel:+918591261438">+91 85912 61438</a><br />
              <a href="tel:+918779150343">+91 87791 50343</a>
            </p>

            <h3>📧 Email</h3>
            <p>
              <a href="mailto:vismitenvision@gmail.com">
                vismitenvision@gmail.com
              </a>
            </p>
          </div>

          {/* ================= CONTACT FORM ================= */}
          <form className="contact-form" onSubmit={handleSubmit}>
            <h3>Send a Message</h3>

            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={form.name}
              onChange={handleChange}
              required
            />

            <input
              type="tel"
              name="mobile"
              placeholder="Your Mobile Number"
              value={form.mobile}
              onChange={handleChange}
              required
            />

            <fieldset className="services-checkboxes">
              <legend>Select Service(s) *</legend>
              {[
                'Portable X-Ray',
                'Portable ECG',
                'Portable Blood Test',
                'At-Home X-Ray for Pets'
              ].map((s) => (
                <label key={s}>
                  <input
                    type="checkbox"
                    name="service"
                    value={s}
                    checked={form.service.includes(s)}
                    onChange={handleChange}
                  />
                  {s}
                </label>
              ))}
            </fieldset>

            <textarea
              name="message"
              rows="4"
              placeholder="Your Message"
              value={form.message}
              onChange={handleChange}
              required
            />

            <button type="submit">Send via WhatsApp</button>

            {status && <p className="form-status">{status}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
